module.exports = __webpack_public_path__ + "img/background-img.cb4830ac.png";